import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiFunction, URL } from "./utils";

export const userAccountApi = createApi({
  reducerPath: "users",
  baseQuery: fetchBaseQuery({
    baseUrl: `${URL.url}`,
    fetchFn: async (...args) => {
      // REMOVE FOR PRODUCTION
      return fetch(...args);
    },
  }),
  tagTypes: ["UserAccount"],
  endpoints: (builder) => ({
    // Kullanıcı listesini getirme
    getAllUsers: builder.query({
      query: (data) => {
        return apiFunction(data, "/api/users/listUsers", "POST");
      },
      providesTags: ["UserAccount"],
    }),

    // Hesap durumunu getirme
    getUserAccountStatus: builder.query({
      query: (data) => {
        return apiFunction(data, "/api/users/get-account-status", "POST");
      },
      providesTags: ["UserAccount"],
    }),

    // Hesabı askıya alma
    suspendUserAccount: builder.mutation({
      query: (data) => {
        return apiFunction(data, "/api/users/suspend-account", "POST");
      },
      invalidatesTags: ["UserAccount"],
    }),

    // Hesabı dondurma
    freezeUserAccount: builder.mutation({
      query: (data) => {
        return apiFunction(data, "/api/users/freeze-account", "POST");
      },
      invalidatesTags: ["UserAccount"],
    }),

    // Hesabı devre dışı bırakma
    disableUserAccount: builder.mutation({
      query: (data) => {
        return apiFunction(data, "/api/users/disable-account", "POST");
      },
      invalidatesTags: ["UserAccount"],
    }),

    // Hesabı aktifleştirme
    activateUserAccount: builder.mutation({
      query: (data) => {
        return apiFunction(data, "/api/users/activate-account", "POST");
      },
      invalidatesTags: ["UserAccount"],
    }),

    // Muhasebeci oluşturma
    createAccountant: builder.mutation({
      query: (data) => {
        return apiFunction(data, "/api/users/create-accountant", "POST");
      },
      invalidatesTags: ["UserAccount"],
    }),

    // Profil güncelleme
    updateProfile: builder.mutation({
      query: (data) => {
        return apiFunction(data, "/api/users/update-profile", "PATCH");
      },
      invalidatesTags: ["UserAccount"],
    }),

    // Şifre değiştirme
    changePassword: builder.mutation({
      query: (data) => {
        return apiFunction(data, "/api/users/change-password", "PATCH");
      },
    }),
  }),
});

export const {
  useGetAllUsersQuery,
  useLazyGetAllUsersQuery,
  useGetUserAccountStatusQuery,
  useSuspendUserAccountMutation,
  useFreezeUserAccountMutation,
  useDisableUserAccountMutation,
  useActivateUserAccountMutation,
  useCreateAccountantMutation,
  useUpdateProfileMutation,
  useChangePasswordMutation,
} = userAccountApi;
